import { render, staticRenderFns } from "./BookCover.vue?vue&type=template&id=1928f8eb&scoped=true"
import script from "./BookCover.vue?vue&type=script&lang=js"
export * from "./BookCover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1928f8eb",
  null
  
)

export default component.exports